import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 7.888888888888488 5.461538461538112",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 7.888888888888488 5.461538461538112\" fill=\"none\" id=\"icon-arrow-up\"><path id=\"icon-arrow-up_三角形 1\" fill-rule=\"evenodd\" style=\"fill:#2E88FF\" transform=\"translate(0 0)  rotate(180 3.9444444444442444 2.7307692307690927)\" opacity=\"1\" d=\"M7.36,1.37L0.53,1.37L3.94,5.46L7.36,1.37Z \" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol